export interface RosterSlotSettings {
  QB?: number;
  RB?: number;
  WR?: number;
  TE?: number;
  K?: number;
  DEF?: number;
  FLEX?: number;
  SUPERFLEX?: number;
}

export const ROSTER_POSITIONS = ['QB', 'RB', 'WR', 'TE', 'K', 'DEF'] as const;

export function positionSlotCount(
  position: string,
  settings: RosterSlotSettings
): number {
  switch (position) {
    case 'QB':
      return (settings.QB || 1) + (settings.SUPERFLEX || 0);
    case 'RB':
      return (settings.RB || 2) + (settings.FLEX || 0);
    case 'WR':
      return (settings.WR || 2) + (settings.FLEX || 0);
    case 'TE':
      return (settings.TE || 1) + (settings.FLEX || 0);
    case 'K':
      return settings.K || 1;
    case 'DEF':
      return settings.DEF || 1;
    default:
      return 0;
  }
}

export function groupPlayersByPosition<T extends { position: string }>(
  players: T[],
  positions: readonly string[] = ROSTER_POSITIONS
): Record<string, T[]> {
  const groups: Record<string, T[]> = {};
  for (const position of positions) {
    groups[position] = players.filter((player) => player.position === position);
  }
  return groups;
}
